module.exports = __webpack_public_path__ + "images/b252e3ef84e88205cc0f2f8769f4cc15.png";